import React from 'react';
import {
  MessageInput,
  useChannelStateContext
} from 'stream-chat-react';
import {
  useStreamChatContext,
  useStreamChatErrors
} from '../../utils/utils';
import { messagingService } from '../../services/messaging-service';
import MessageInputBase from './stream-message-input-base';

export const StreamMessageInput = () => {
  const { channel } = useChannelStateContext();

  const {
    generateMessageMetadata,
    accessToken
  } = useStreamChatContext();

  const {
    addInputErrorIds,
    clearInputErrors
  } = useStreamChatErrors();

  const uploadAsset = async (file, channel) => {
    return messagingService.uploadAsset(file, channel, accessToken);
  };

  const handleSubmit = async (message) => {
    await messagingService.sendMessage(message, channel, generateMessageMetadata, clearInputErrors, addInputErrorIds);
  };

  return <MessageInput
    disableMentions
    Input={MessageInputBase}
    overrideSubmitHandler={handleSubmit}
    doImageUploadRequest={uploadAsset}
    doFileUploadRequest={(file, channel) => messagingService.uploadAsset(file, channel, accessToken)}
  />;
};
